import { configureCopyToClipboard } from '../../components/clipboard'
import { loadTooltips } from '../../utils/common'
import { initEmailStatusModal } from '../../components/email_status'

import { initOfferResponseModal } from './offer_response_modal'
import { initApplicationInvitation } from './application_invitations'
import { initPaymentDetail } from './application_payment_detail'

function loadFormTab() {
  import('./application_form')
}

function loadAttachmentsTab() {
  const dataElement = document.querySelector<HTMLElement>('[data-application]')

  if (!dataElement || !dataElement.dataset.application) {
    return
  }
  const application = JSON.parse(dataElement.dataset.application)

  import('../../components/attachments').then(({ configureAttachments }) => {
    configureAttachments({
      renderNoAttachmentPath:
        '/partner/applications/attachments/render_no_attachment',
      renderUploadedPath: '/partner/applications/attachments/render_uploaded',
      deleteAttachmentPath: `/api/v1/application/${application.id}/attachment/`,
      createAttachmentPath: `/api/v1/application/${application.id}/create_attachment`,
      pendingAttachmentPath: '/partner/applications/attachments/render_pending',
      resyncAttachmentPath: `/api/v1/application/${application.id}/resync_attachment/`,
      canEdit: application.isEditable,
    })
  })
}

function initApplicationDetail() {
  // Guard against double-initialisation. The deployed page-init bundle can
  // evaluate this dispatch more than once (code-splitting on the production
  // build duplicates the entry), which binds every listener on the page twice.
  // For the voucher payment button that meant a single click fired two
  // `voucher_payment` requests and redeemed the voucher twice (PP-3773).
  // A DOM marker is used instead of a module-level flag so the guard still
  // holds if the module itself is evaluated twice.
  if (document.body.dataset.applicationDetailInitialised) {
    return
  }
  document.body.dataset.applicationDetailInitialised = 'true'

  const tab = document.querySelector<HTMLElement>('[data-active-tab]')
  switch (tab?.dataset.activeTab) {
    case 'form':
      loadFormTab()
      break
    case 'attachments':
      loadAttachmentsTab()
      break
  }
  const copyToClipboardElements =
    document.querySelectorAll<HTMLElement>('.copy-to-clipboard')
  for (const element of copyToClipboardElements) {
    configureCopyToClipboard(element)
  }

  loadTooltips()
  initOfferResponseModal()
  initPaymentDetail()
  initApplicationInvitation()
  initEmailStatusModal()
}

export { initApplicationDetail }
